import { useQuery } from '@apollo/client';

import { useThirdPartyOrganization } from 'bundles/admin-dashboard/components/ThirdPartyOrganizationProvider';
import { useProgram } from 'bundles/enterprise-admin-ai-program-builder/hooks/useProgram';
import programGenerationRequestQuery from 'bundles/enterprise-admin-ai-program-builder/queries/QueryProgramGenerationRequestByProgramId.graphql';
import type {
  QueryProgramGenerationRequestByProgramIdQuery,
  QueryProgramGenerationRequestByProgramIdQueryVariables,
} from 'bundles/enterprise-admin-ai-program-builder/queries/__generated__/QueryProgramGenerationRequestByProgramId';

export const useProgramGenerationRequestQuery = () => {
  const program = useProgram();
  const org = useThirdPartyOrganization();
  const { data, refetch, error, loading } = useQuery<
    QueryProgramGenerationRequestByProgramIdQuery,
    QueryProgramGenerationRequestByProgramIdQueryVariables
  >(programGenerationRequestQuery, {
    context: { clientName: 'gatewayGql' },
    skip: !program?.id,
    variables: {
      programId: program?.id ?? '',
      thirdPartyOrganizationId: org.id,
    },
  });
  const programGenerationRequest = data?.EnterpriseProgram?.queryProgramGenerationRequestByProgramId;
  return { programGenerationRequest, refetch, error, loading };
};
